export function XeroSupportFindMatchesForInvoiceCtrl ($scope, domainParserApi, invoices) {

  $scope.invoices = invoices ? invoices : {};

  // IE specific properties to enable flipper modal compatibility
  $scope.IE = domainParserApi.isInternetExplorer();
  $scope.flipped = false;

  $scope.tableSettings = {
    columns: [
      {
        field : 'InvoiceID',
        header: {
          text: 'ID'
        }
      },
      {
        field : 'Date',
        header: {
          text: 'Date'
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.flipped = !$scope.flipped;
    $scope.invoice = event.row;
    $('.modal-content').addClass('flip');
  };

  $scope.back = function () {
    $('.modal-content').removeClass('flip');
  };

}